import { CardActionType } from "./action-type"

export const actionSendProposalCardBenefit = (payload, callBack, errCallBack) => ({
    type: CardActionType.SEND_PROPOSAL_CARD_BENEFIT,
    payload,
    callBack,
    errCallBack
});

export const actionSendProposalCardBmg = (payload, callBack, errCallBack) => ({
    type: CardActionType.SEND_PROPOSAL_CARD_BMG,
    payload,
    callBack,
    errCallBack
});

export const actionSendProposalCardMaster = (payload, callBack, errCallBack) => ({
    type: CardActionType.SEND_PROPOSAL_CARD_MASTER,
    payload,
    callBack,
    errCallBack
});